<app-card [isHeader]=true [title]="'search_filter'|translate">

    <form [formGroup]="form" style="    flex-direction: column;
      ">

        <div class="cp5" fxFlex="100" fxLayout="row wrap" fxLayoutAlign="start center">

            <ng-container *ngIf="acheteur && hide==true">
                <div fxFlex="100" fxFlex.lt-md="100">
                    <app-combo-acheteur #s
                                        (object)="getobject($event)" [control]="getFormControl('instNm')"
                                        [label]="'Acheteur Public' | translate"></app-combo-acheteur>
                </div>
                <!-- <div fxFlex="100" fxFlex.lt-md="100" *ngIf="getlang() == 'fr'">
                  <app-select-acheteur-public
                  (object)="getobject($event)"
                  #s

                    [withfiltre]="true"
                    [control]="getFormControl('instNm')"
                  ></app-select-acheteur-public>
                </div>
                <div fxFlex="100" fxFlex.lt-md="100" *ngIf="getlang() == 'ar'">
                  <app-select-acheteur-public
                  (object)="getobject($event)"
                  #s

                    [withfiltre]="true"
                    [control]="getFormControl('instNmAr')"
                  ></app-select-acheteur-public>
                </div>
                <div fxFlex="100" fxFlex.lt-md="100" *ngIf="getlang() == 'en'">
                  <app-select-acheteur-public
                  (object)="getobject($event)"
                  #s

                    [withfiltre]="true"
                    [control]="getFormControl('instNmEn')"
                  ></app-select-acheteur-public>
                </div> -->
            </ng-container>
            <ng-container *ngIf="!hide">
                <div fxFlex="100" fxFlex.lt-md="100">
                    <app-text-field [control]="getFormControl('staffDeptNm')"
                                    [label]="nom_soc | translate"></app-text-field>
                </div>
            </ng-container>
            <ng-container>
                <div fxFlex="100" fxFlex.lt-md="100">
                    <app-text-field [control]="getFormControl('masterCd')" [label]="'Identifiant unique'| translate"
                                    [max]="14"></app-text-field>
                </div>
            </ng-container>

            <ng-container *ngIf="!hide">
                <div fxFlex="50" fxFlex.lt-md="100">
                    <app-text-field [control]="getFormControl('staffNm')"
                                    [label]="'Nom Et Prénom' | translate"></app-text-field>
                </div>

                <div fxFlex="50" fxFlex.lt-md="100">
                    <app-text-field [control]="getFormControl('userId')"
                                    [label]="'ID Utilisateur' | translate"></app-text-field>
                </div>
            </ng-container>


        </div>

        <!-- app-select-acheteur-common -->

        <div fxLayoutAlign="end">
            <div>
                <button (click)="submit()" class="filter-btn" color="primary" mat-flat-button
                        style="background-color: #3498db;">
                    <mat-icon>{{ icons.search }}</mat-icon>
                    <span translate>search</span>
                </button>
            </div>
            <div style="margin-left: 1%;margin-right: 1%;">
                <button (click)="reset()" class="filter-btn" color="primary" mat-flat-button>
                    <mat-icon>{{ icons.reset }}</mat-icon>
                    <span translate>reset</span>
                </button>

            </div>

        </div>


    </form>

</app-card>
